module.exports = function() {
  return new Worker(__webpack_public_path__ + "a43a65f837bc7798c32a.worker.js");
};